<div id="banner-cookie" class="container-fluid nav-cookies">
    <div class="row justify-content-center">
        <div class="col-12 col-lg-11">
            <div class="row">
                <div class="col-12 col-md-8">
                    <a href="javascript:void(0)" class="link-fechar d-block d-md-none " (click)="hideCookies(false)">x</a>
                    <p class="nav-cookies-text px-3 d-none d-md-block">
                        Clicando em "Aceito", você concorda com o armazenamento de cookies no seu dispositivo para melhorar a experiência de navegação no site. Clique em SABER MAIS para configurar suas preferências.
                    </p>
                    <p class="nav-cookies-text px-3 d-block d-md-none">
                        Clicando em "Aceito", você concorda com o armazenamento de cookies no seu dispositivo para melhorar a experiência de navegação no site. Clique <a href="javascript:void(0)" id="showPolicy" (click)="showTermsCookies()">AQUI</a> para configurar suas preferências.
                    </p>
                </div>
                <div class="col-12 col-md-4">
                    <p class="d-none d-md-block">
                        <button type="button" class="btn btn-aceito" (click)="hideCookies(true)">Aceito</button>
                        <button id="showPolicy" type="button" class="btn btn-link btn-saber-mais" (click)="showTermsCookies()">Saber mais</button>
                        <a href="javascript:void(0)" class="link-fechar" (click)="hideCookies(false)">x</a>
                    </p>

                    <p class="d-block d-md-none text-center">
                        <button type="button" class="btn btn-aceito" (click)="hideCookies(true)">Aceito</button>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalCookie" tabindex="-1" role="dialog" aria-labelledby="modalCookieLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content bg-modal-cookie">
            <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <p class="text-justify;">
                    Os cookies necessários são aqueles fundamentais para o site funcionar e não podem ser desligados de nosso sistema. Eles geralmente são definidos apenas em resposta às ações feitas por você, como por exemplo, fazer login ou preencher formulários. Também capturamos cookies analíticos, que são aqueles que fornecem informações sobre como este site está sendo usado para que possamos melhorar a experiência do usuário. Os dados capturados são agregados e anonimizados. Veja nosso <a href="https://www.reachr.com.br/termos-de-uso" class="saibaMaisLink"><strong>Termo de Uso</strong></a> e nossa <a href="https://www.reachr.com.br/politica-de-privacidade" class="saibaMaisLink"><strong>Política de Privacidade</strong></a>. Também são armazenados cookies de marketing, que fornecem informações sobre a interação do usuário com o conteúdo de nossos sites, ajudando-nos a entender melhor a eficácia do nosso conteúdo de e-mail, redes sociais e websites.
                </p>    
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-recusar" data-dismiss="modal">Recusar</button>
                <button type="button" class="btn btn-aceito" (click)="hideCookies(true)">Aceito</button>
            </div>
        </div>
    </div>
</div>
